module.exports = __webpack_public_path__ + "front/img/21.36d36782.png";